export const mediaQueries = {
  mobile: { maxWidth: 767 },
};
